import tinycolor from "tinycolor2";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { TextInteractor } from './TextInteractor';
import { CameraMode } from "@egr/wcf/modules/core/view/CameraControl";
import { Interactor, InteractorType } from "@egr/wcf/modules/core/tool/Interactor";
import { InteractorManager } from "@egr/wcf/modules/core/tool";
import { Log } from "@egr/wcf/modules/utils";
import { VECTOR3_Y } from '@egr/wcf/modules/core/utils/MathUtils';
import { loadContentAsBlobUrl } from "@egr/wcf/modules/utils/dom";
import { toLocaleLengthString } from "@egr/wcf/modules/utils/number";
export class AbstractInteractors {
    constructor(pRoomManager) {
        this.mApp = pRoomManager.app;
        this.mRoomManager = pRoomManager;
        this.mInteractorManager = new InteractorManager(this.mApp.viewer);
        this.mInteractorManager.enabled = false;
    }
    get manager() {
        return (this.mInteractorManager);
    }
    dispose() {
        this.mInteractorManager.dispose();
    }
    static async PrepareSprite(pDataPath) {
        if (AbstractInteractors.sSpriteUrl == null)
            AbstractInteractors.sSpriteUrl = await loadContentAsBlobUrl(pDataPath + "images/sprite.svg");
    }
    lengthToString(pValue, pAddUnit = false) {
        let tString = toLocaleLengthString(pValue, this.mApp.i18n.locale, this.mApp.i18n.lengthUnit, pAddUnit);
        return (tString != null ? tString : pValue.toString());
    }
    // tslint:disable-next-line:cyclomatic-complexity
    createInteractor(pClass, pPosition, pPosOffsetDir = null, pPosOffset = 0, p3dRotation = null, pShowSprite = false, pAllwaysVisible = false, pScaling, pColor) {
        this.mGetInteractorsPromise = this.getAndCreateInteractors().then(() => {
            this.mGetInteractorsPromise = null;
        }).catch((pError) => {
            this.mGetInteractorsPromise = null;
            Log.error("Failed to get room interactors.", pError);
        });
        let tElement = document.createElement("div");
        if (pClass === "plus-interactor") {
            let tFillColor = this.mRoomManager.app.theme.mainColorBright;
            if (pColor !== undefined) {
                tFillColor = pColor;
            }
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g1 = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g1);
            let tcircle1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            tcircle1.setAttribute("r", "11.75");
            tcircle1.setAttribute("cy", "12");
            tcircle1.setAttribute("cx", "12");
            tcircle1.setAttribute("fill", "#FFFFFF");
            g1.appendChild(tcircle1);
            let path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path1.setAttribute("d", "M12,0.5c6.341,0,11.5,5.159,11.5,11.5S18.341,23.5,12,23.5S0.5,18.341,0.5,12S5.659,0.5,12,0.5 M12,0, C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12S18.627,0,12,0L12,0z");
            path1.setAttribute("fill", "#B2B2B2");
            g1.appendChild(path1);
            let g2 = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g2);
            let tcircle2 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            tcircle2.setAttribute("r", "10");
            tcircle2.setAttribute("cy", "12");
            tcircle2.setAttribute("cx", "12");
            tcircle2.setAttribute("fill", tFillColor);
            g2.appendChild(tcircle2);
            let telem1 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            telem1.setAttribute("x", "6");
            telem1.setAttribute("y", "11");
            telem1.setAttribute("width", "12");
            telem1.setAttribute("height", "2");
            telem1.setAttribute("fill", "#ffffff");
            svg.appendChild(telem1);
            let telem2 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            telem2.setAttribute("x", "6");
            telem2.setAttribute("y", "11");
            telem2.setAttribute("width", "12");
            telem2.setAttribute("height", "2");
            telem2.setAttribute("fill", "#ffffff");
            telem2.setAttribute("transform", "matrix(-1.836970e-16 1 -1 -1.836970e-16 24 1.776357e-15)");
            svg.appendChild(telem2);
            tElement.appendChild(svg);
        }
        if (pClass === "deletePoint-interactor") {
            let tFillColor = "#005BA1";
            if (pColor !== undefined) {
                tFillColor = pColor;
            }
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g);
            let path2 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            path2.setAttribute("r", "11.75");
            path2.setAttribute("cy", "12");
            path2.setAttribute("cx", "12");
            path2.setAttribute("fill", "#FFFFFF");
            g.appendChild(path2);
            let path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path1.setAttribute("d", "M12,0.5c6.341,0,11.5,5.159,11.5,11.5S18.341,23.5,12,23.5S0.5,18.341,0.5,12S5.659,0.5,12,0.5 M12,0, C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12S18.627,0,12,0L12,0z");
            path1.setAttribute("fill", "#B2B2B2");
            g.appendChild(path1);
            let g2 = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g2);
            let tcircle2 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            tcircle2.setAttribute("r", "10");
            tcircle2.setAttribute("cy", "12");
            tcircle2.setAttribute("cx", "12");
            tcircle2.setAttribute("fill", tFillColor);
            g2.appendChild(tcircle2);
            let trect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            trect.setAttribute("x", "6");
            trect.setAttribute("y", "11");
            trect.setAttribute("width", "12");
            trect.setAttribute("height", "2");
            trect.setAttribute("fill", "#FFFFFF");
            svg.appendChild(trect);
            tElement.appendChild(svg);
        }
        if (pClass === "trash-interactor") {
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g);
            let path0 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            path0.setAttribute("r", "12");
            path0.setAttribute("cy", "12");
            path0.setAttribute("cx", "12");
            path0.setAttribute("fill", "#FFFFFF");
            g.appendChild(path0);
            let path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path1.setAttribute("d", "M15.62,10.087l0,8.381l-7.24,0l0,-8.381l7.24,0m1.032,-1.033l-1.032,0l-7.24,0l-1.036,0l0,10.446l9.308,0l0,-1.032l0,-8.381l0,-1.033Z");
            path1.setAttribute("fill", "#868686");
            path1.setAttribute("fill-rule", "nonzero");
            g.appendChild(path1);
            let telem2 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            telem2.setAttribute("x", "6.828");
            telem2.setAttribute("y", "6.568");
            telem2.setAttribute("width", "10.344");
            telem2.setAttribute("height", "3.104");
            telem2.setAttribute("fill", "non");
            telem2.setAttribute("stroke", "#868686");
            telem2.setAttribute("stroke-width", "1.02px");
            g.appendChild(telem2);
            let telem3 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            telem3.setAttribute("x", "9.932");
            telem3.setAttribute("y", "4.5");
            telem3.setAttribute("width", "4.136");
            telem3.setAttribute("height", "2.068");
            telem3.setAttribute("fill", "non");
            telem3.setAttribute("stroke", "#868686");
            telem3.setAttribute("stroke-width", "1.02px");
            telem3.setAttribute("stroke-linejoin", "round");
            g.appendChild(telem3);
            let telem4 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            telem4.setAttribute("d", "M9.932,9.156l0,9.308");
            telem4.setAttribute("fill", "none");
            telem4.setAttribute("fill-rule", "nonzero");
            telem4.setAttribute("stroke", "#868686");
            telem4.setAttribute("stroke-width", "1.02px");
            telem4.setAttribute("stroke-linejoin", "round");
            g.appendChild(telem4);
            let telem5 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            telem5.setAttribute("d", "M12,9.156l0,9.308");
            telem5.setAttribute("fill", "none");
            telem5.setAttribute("fill-rule", "nonzero");
            telem5.setAttribute("stroke", "#868686");
            telem5.setAttribute("stroke-width", "1.02px");
            telem5.setAttribute("stroke-linejoin", "round");
            g.appendChild(telem5);
            let telem6 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            telem6.setAttribute("d", "M14.068,9.156l0,9.308");
            telem6.setAttribute("fill", "none");
            telem6.setAttribute("fill-rule", "nonzero");
            telem6.setAttribute("stroke", "#868686");
            telem6.setAttribute("stroke-width", "1.02px");
            telem6.setAttribute("stroke-linejoin", "round");
            g.appendChild(telem6);
            tElement.appendChild(svg);
        }
        if (pClass === "viewAlongPath-interactor") {
            let tfillColor = "#95C11F";
            if (pColor !== undefined) {
                tfillColor = pColor;
            }
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g);
            let telem0 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            telem0.setAttribute("r", "11.75");
            telem0.setAttribute("cy", "12");
            telem0.setAttribute("cx", "12");
            telem0.setAttribute("fill", "#ffffff");
            g.appendChild(telem0);
            let telem2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            telem2.setAttribute("d", "M12,0.5c6.341,0,11.5,5.159,11.5,11.5S18.341,23.5,12,23.5S0.5,18.341,0.5,12S5.659,0.5,12,0.5 M12,0, C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12S18.627,0,12,0L12,0z");
            telem2.setAttribute("fill", "#B2B2B2");
            g.appendChild(telem2);
            let g1 = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g1);
            let telem1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            telem1.setAttribute("r", "10");
            telem1.setAttribute("cy", "12");
            telem1.setAttribute("cx", "12");
            telem1.setAttribute("fill", tfillColor);
            g1.appendChild(telem1);
            let tpolygon = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
            tpolygon.setAttribute("fill", "#FFFFFF");
            tpolygon.setAttribute("points", "4,12 10,7 10,17 ");
            svg.appendChild(tpolygon);
            let rect1 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            rect1.setAttribute("x", "11");
            rect1.setAttribute("y", "10");
            rect1.setAttribute("width", "2");
            rect1.setAttribute("height", "4");
            rect1.setAttribute("fill", "#ffffff");
            svg.appendChild(rect1);
            let rect2 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            rect2.setAttribute("x", "14");
            rect2.setAttribute("y", "10");
            rect2.setAttribute("width", "2");
            rect2.setAttribute("height", "4");
            rect2.setAttribute("fill", "#ffffff");
            svg.appendChild(rect2);
            let rect3 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            rect3.setAttribute("x", "17");
            rect3.setAttribute("y", "10");
            rect3.setAttribute("width", "2");
            rect3.setAttribute("height", "4");
            rect3.setAttribute("fill", "#ffffff");
            svg.appendChild(rect3);
            tElement.appendChild(svg);
        }
        if (pClass === "notViewAlongPath-interactor") {
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g);
            let telem0 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            telem0.setAttribute("r", "12");
            telem0.setAttribute("cy", "12");
            telem0.setAttribute("cx", "12");
            telem0.setAttribute("fill", "#ffffff");
            g.appendChild(telem0);
            let telem1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            telem1.setAttribute("r", "10");
            telem1.setAttribute("cy", "12");
            telem1.setAttribute("cx", "12");
            telem1.setAttribute("fill", "#6e6e6e");
            g.appendChild(telem1);
            let telem2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            telem2.setAttribute("d", "M15.848,6.116c-5.829,-5.338 -12.869,5.264 -3.692,5.868c9.88,0.652 1.464,11.414 -4.671,5.45");
            telem2.setAttribute("fill", "none");
            telem2.setAttribute("stroke", "#ff0000");
            telem2.setAttribute("stroke-width", "3px");
            g.appendChild(telem2);
            let telem3 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            telem3.setAttribute("d", "M18.787,8.713c-3.303,1.429 -10.134,4.145 -13.75,5.67");
            telem3.setAttribute("fill", "#ff0000");
            telem3.setAttribute("stroke", "#000000");
            telem3.setAttribute("stroke-width", "3px");
            g.appendChild(telem3);
            tElement.appendChild(svg);
        }
        if (pClass === "textsize-interactor") {
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g);
            let path2 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            path2.setAttribute("r", "12");
            path2.setAttribute("cy", "12");
            path2.setAttribute("cx", "12");
            path2.setAttribute("fill", "#FFFFFF");
            g.appendChild(path2);
            let path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            let tSVGPath = "M 12 2 C 6.48 2 2 6.48 2 12 C 2 17.52 6.48 22 12 22 C 17.52 22 22 17.52 22 12 C 22 6.48 17.52 2 12 2 z " +
                "M 12.810547 6.0039062 C 14.435075 6.1002586 16.059599 6.1959553 17.685547 6.2949219 " +
                "C 17.783536 7.9203392 17.881184 9.5459253 17.976562 11.169922 L 16.230469 9.4238281 " +
                "L 9.4238281 16.230469 L 11.189453 17.996094 C 9.5640374 17.898107 7.9384504 17.800458 6.3144531 17.705078 " +
                "C 6.2164672 16.079662 6.1188115 14.454072 6.0234375 12.830078 L 7.7792969 14.585938 L 14.585938 7.7792969 L 12.810547 6.0039062 z ";
            path1.setAttribute("d", tSVGPath);
            path1.setAttribute("fill", this.mRoomManager.app.theme.mainColorBright);
            g.appendChild(path1);
            tElement.appendChild(svg);
        }
        if (pClass === "scale-interactor") {
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g);
            let rect1 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            rect1.setAttribute("x", "2");
            rect1.setAttribute("y", "2");
            rect1.setAttribute("width", "22");
            rect1.setAttribute("height", "22");
            rect1.setAttribute("fill", "#ffffff");
            g.appendChild(rect1);
            let rect2 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            rect2.setAttribute("x", "4");
            rect2.setAttribute("y", "4");
            rect2.setAttribute("width", "18");
            rect2.setAttribute("height", "18");
            rect2.setAttribute("fill", this.mRoomManager.app.theme.mainColorBright);
            g.appendChild(rect2);
            tElement.appendChild(svg);
        }
        if (pClass === "linetool-interactor") {
            let tFillColor = this.mRoomManager.app.theme.mainColorBright;
            if (pColor !== undefined) {
                tFillColor = pColor;
            }
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g);
            let tpath = document.createElementNS("http://www.w3.org/2000/svg", "path");
            tpath.setAttribute("d", "m8.56265,0l-8.392,10.827l0,4.173l3.752,-1.499l8.248,-10.896l-3.608,-2.605zm-5.176,12.317l-1.898,-1.336l6.64,-8.435l1.743,1.271l-6.485,8.5z");
            tpath.setAttribute("fill", tFillColor);
            tpath.setAttribute("fill-rule", "nonzero");
            g.appendChild(tpath);
            let tpath1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            tpath1.setAttribute("d", "m0.17065,15.5l13,0");
            tpath1.setAttribute("fill", "none");
            tpath1.setAttribute("fill-rule", "nonzero");
            tpath1.setAttribute("stroke", tFillColor);
            tpath1.setAttribute("stroke-width", "1px");
            g.appendChild(tpath1);
            tElement.appendChild(svg);
        }
        if (pClass === "move-interactor") {
            let tcol = new tinycolor(this.mRoomManager.app.theme.mainColorBright);
            tcol.darken(10);
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g);
            let path1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            path1.setAttribute("r", "24");
            path1.setAttribute("cy", "10");
            path1.setAttribute("cx", "10");
            path1.setAttribute("fill", "#FFFFFF");
            g.appendChild(path1);
            let path2 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            path2.setAttribute("r", "10");
            path2.setAttribute("cy", "12");
            path2.setAttribute("cx", "12");
            path2.setAttribute("fill", tcol.toHexString());
            g.appendChild(path2);
            tElement.appendChild(svg);
        }
        if (pClass === "dot-interactor") {
            let tfillColor = this.mRoomManager.app.theme.mainColorBright;
            if (pColor !== undefined) {
                tfillColor = pColor;
            }
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g);
            let telem0 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            telem0.setAttribute("r", "11.75");
            telem0.setAttribute("cy", "12");
            telem0.setAttribute("cx", "12");
            telem0.setAttribute("fill", "#FFFFFF");
            g.appendChild(telem0);
            let telem1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            telem1.setAttribute("d", "M12,0.5c6.341,0,11.5,5.159,11.5,11.5S18.341,23.5,12,23.5S0.5,18.341,0.5,12S5.659,0.5,12,0.5 M12,0, C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12S18.627,0,12,0L12,0z");
            telem1.setAttribute("fill", "#B2B2B2");
            g.appendChild(telem1);
            let telem2 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            telem2.setAttribute("r", "10");
            telem2.setAttribute("cy", "12");
            telem2.setAttribute("cx", "12");
            telem2.setAttribute("fill", tfillColor);
            g.appendChild(telem2);
            tElement.appendChild(svg);
        }
        if (pClass === "cammove-interactor") {
            let tfillColor = this.mRoomManager.app.theme.mainColorBright;
            if (pColor !== undefined) {
                tfillColor = pColor;
            }
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g);
            let tcircle1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            tcircle1.setAttribute("r", "11.75");
            tcircle1.setAttribute("cy", "12");
            tcircle1.setAttribute("cx", "12");
            tcircle1.setAttribute("fill", "#FFFFFF");
            g.appendChild(tcircle1);
            let path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path1.setAttribute("d", "M12,0.5c6.341,0,11.5,5.159,11.5,11.5S18.341,23.5,12,23.5C5.659,23.5,0.5,18.341,0.5,12S5.659,0.5,12,0.5, M12,0C5.373,0,0,5.373,0,12s5.373,12,12,12c6.627,0,12-5.373,12-12S18.627,0,12,0L12,0z");
            path1.setAttribute("fill", "#B2B2B2");
            g.appendChild(path1);
            let g1 = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g1);
            let tcircle2 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            tcircle2.setAttribute("r", "10");
            tcircle2.setAttribute("cy", "12");
            tcircle2.setAttribute("cx", "12");
            tcircle2.setAttribute("fill", tfillColor);
            g1.appendChild(tcircle2);
            let rect1 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            rect1.setAttribute("x", "6");
            rect1.setAttribute("y", "11");
            rect1.setAttribute("width", "12");
            rect1.setAttribute("height", "2");
            rect1.setAttribute("fill", "#ffffff");
            svg.appendChild(rect1);
            let rect2 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            rect2.setAttribute("x", "6");
            rect2.setAttribute("y", "11");
            rect2.setAttribute("width", "12");
            rect2.setAttribute("height", "2");
            rect2.setAttribute("transform", "matrix(-1.836970e-16 1 -1 -1.836970e-16 24 1.776357e-15)");
            rect2.setAttribute("fill", "#ffffff");
            svg.appendChild(rect2);
            let tpolygon = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
            tpolygon.setAttribute("fill", "#FFFFFF");
            tpolygon.setAttribute("points", "9,8 12,4 15,8 ");
            svg.appendChild(tpolygon);
            let tpolygon1 = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
            tpolygon1.setAttribute("fill", "#FFFFFF");
            tpolygon1.setAttribute("points", "15,16 12,20 9,16 ");
            svg.appendChild(tpolygon1);
            let tpolygon2 = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
            tpolygon2.setAttribute("fill", "#FFFFFF");
            tpolygon2.setAttribute("points", "8,15 4,12 8,9 ");
            svg.appendChild(tpolygon2);
            let tpolygon3 = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
            tpolygon3.setAttribute("fill", "#FFFFFF");
            tpolygon3.setAttribute("points", "16,9 20,12 16,15 ");
            svg.appendChild(tpolygon3);
            tElement.appendChild(svg);
        }
        if (pClass === "moveHeight-interactor") {
            let tcol = new tinycolor(this.mRoomManager.app.theme.mainColorBright);
            tcol.darken(10);
            if (pColor !== undefined) {
                tcol = new tinycolor(pColor);
            }
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g);
            let path3 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            // path3.setAttribute("d", "M4.446,16.795l0,-9.59l-3.42,0l4.974,-6.393l4.974,6.393l-3.419,0l0,9.59l3.419,0l-4.974,6.393l-4.974,-6.393l3.42,0Z");
            path3.setAttribute("d", "m10 17v-10h-3l5-6 5 6h-3v10h3l-5 6-5-6h3z");
            path3.setAttribute("fill", tcol.toHexString());
            path3.setAttribute("stroke", "#fff");
            path3.setAttribute("stroke-width", "1px");
            g.appendChild(path3);
            tElement.appendChild(svg);
        }
        if (pClass === "eye-interactor") {
            let tfillColor = "#95C11F";
            if (pColor !== undefined) {
                tfillColor = pColor;
            }
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g0 = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g0);
            let tcircle1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            tcircle1.setAttribute("r", "11.75");
            tcircle1.setAttribute("cy", "12");
            tcircle1.setAttribute("cx", "12");
            tcircle1.setAttribute("fill", "#FFFFFF");
            g0.appendChild(tcircle1);
            let tpath1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            tpath1.setAttribute("d", "M12,0.5c6.341,0,11.5,5.159,11.5,11.5S18.341,23.5,12,23.5S0.5,18.341,0.5,12S5.659,0.5,12,0.5 M12,0, C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12S18.627,0,12,0L12,0z");
            tpath1.setAttribute("fill", "#B2B2B2");
            g0.appendChild(tpath1);
            let g1 = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g1);
            let tcircle2 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            tcircle2.setAttribute("r", "10");
            tcircle2.setAttribute("cy", "12");
            tcircle2.setAttribute("cx", "12");
            tcircle2.setAttribute("fill", tfillColor);
            g1.appendChild(tcircle2);
            let path3 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path3.setAttribute("d", "M5,12c0,0,3-4,7-4s7,4,7,4s-2,4-7,4S5,12,5,12z");
            path3.setAttribute("fill", "#ffffff");
            svg.appendChild(path3);
            let g2 = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g2);
            let tcircle3 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            tcircle3.setAttribute("r", "2.5");
            tcircle3.setAttribute("cy", "12");
            tcircle3.setAttribute("cx", "12");
            tcircle3.setAttribute("fill", "#FFFFFF");
            g2.appendChild(tcircle3);
            let tpath4 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            tpath4.setAttribute("d", "M12,10c1.105,0,2,0.895,2,2s-0.895,2-2,2s-2-0.895-2-2S10.895,10,12,10 M12,9c-1.654,0-3,1.346-3,3, s1.346,3,3,3s3-1.346,3-3S13.654,9,12,9L12,9z");
            tpath4.setAttribute("fill", tfillColor);
            g2.appendChild(tpath4);
            tElement.appendChild(svg);
        }
        if (pClass === "arrowH-interactor") {
            let tcol = new tinycolor(this.mRoomManager.app.theme.mainColorBright);
            tcol.darken(10);
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g);
            let path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path1.setAttribute("d", "M 12,1.0000007 6,7.3976803 H 9.1317697 V 16.60232 H 6 L 12,23 17.999999,16.60232 H 14.86823 V 7.3976803 h 3.131769 z");
            path1.setAttribute("fill", "#FFFFFF");
            g.appendChild(path1);
            let path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path2.setAttribute("d", "M 11.9986,2.9151607 8.5864499,6.5520905 H 10.92196 V 17.5862 h 2.15327 V 6.5520905 h 2.338319 z M 8.5864499,17.59063 11.9986,21.22756 15.413549,17.59063 Z");
            path2.setAttribute("fill", tcol.toHexString());
            g.appendChild(path2);
            tElement.appendChild(svg);
        }
        if (pClass === "safetyzone-interactor") {
            let tcol = new tinycolor(this.mRoomManager.app.theme.mainColorBright);
            tcol.darken(10);
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svg.appendChild(g);
            let tPolygons = [];
            tPolygons.push("11.978315914561106,13.468666230560968 17.939560784520832,7.5074194621482615 13.468627132051038,7.5074194621482615 13.468627132051038,0.055862151086330414 10.488004697071174,0.055862151086330414 10.488004697071174,7.5074194621482615 6.017069146148399,7.5074194621482615 ");
            tPolygons.push("2.1035464427625055,20.547646174784504 0.05582350865006447,23.900845702216984 3.0364462365552907,23.900845702216984 3.0364462365552907,22.41053543395354 2.7024362163674294,22.41053543395354 3.385010509198663,21.307695621761567 ");
            tPolygons.push("16.44925051625739,16.449288665540834 16.44925051625739,17.939598933804277 19.429872951237254,17.939598933804277 19.429872951237254,16.449288665540834 ");
            tPolygons.push("11.978315914561106,16.449288665540834 11.978315914561106,17.939598933804277 14.95893834954097,17.939598933804277 14.95893834954097,16.449288665540834 ");
            tPolygons.push("7.507380838251576,16.449288665540834 7.507380838251576,17.939598933804277 10.488004697071174,17.939598933804277 10.488004697071174,16.449288665540834 ");
            tPolygons.push("3.0364462365552907,19.005166418663052 4.313544573060026,19.77119789097638 5.847153333024691,17.216799032724666 4.526757454045223,16.449288665540834 ");
            tPolygons.push("20.920185117953675,21.344967949094766 19.643086306835695,20.578936476781436 18.109478021484275,23.13333723348613 19.429872951237254,23.900845702216984 ");
            for (let tPoly of tPolygons) {
                let path11 = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
                path11.setAttribute("points", tPoly);
                path11.setAttribute("fill", this.mRoomManager.app.theme.mainColorBright);
                g.appendChild(path11);
            }
            let path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path1.setAttribute("d", "m23.900971,16.449292l-2.980623,0l0,1.490293l0.347236,0l-0.685534,1.144559l1.27719,0.767546c0,0 0.693007,-1.153534 1.147526,-1.910603l0,0l0.894206,-1.491795z");
            path1.setAttribute("fill", this.mRoomManager.app.theme.mainColorBright);
            g.appendChild(path1);
            let tRects = [
                ["1.490311", "2.980623", "22.410549", "4.526914"],
                ["1.490311", "2.980623", "22.410549", "8.997859"],
                ["1.490311", "2.980623", "22.410549", "13.46879"],
                ["1.490311", "1.490311", "16.449295", "4.526914"],
                ["1.490311", "1.490311", "22.410549", "17.939725"]
            ];
            for (let tRE of tRects) {
                let path2 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                path2.setAttribute("height", tRE[0]);
                path2.setAttribute("width", tRE[1]);
                path2.setAttribute("y", tRE[2]);
                path2.setAttribute("x", tRE[3]);
                path2.setAttribute("fill", this.mRoomManager.app.theme.mainColorBright);
                g.appendChild(path2);
            }
            tElement.appendChild(svg);
        }
        if (pClass === "text-interactor") {
            let tSpan = document.createElement("div");
            if (pShowSprite)
                tSpan.style.backgroundImage = "url('" + this.mRoomManager.dataPath + "images/sprite.svg')";
        }
        else {
            let tSpan = document.createElement("span");
            if (pShowSprite)
                tSpan.style.backgroundImage = "url('" + this.mRoomManager.dataPath + "images/sprite.svg')";
            tElement.appendChild(tSpan);
        }
        tElement.className = "wcf-room " + pClass;
        if (pClass === "text-interactor") {
            tElement.style.width = "10px";
            tElement.style.height = "10px";
        }
        if ((pClass === "size-interactor") && (pScaling !== undefined)) {
            tElement.style.width = pScaling.x + "px";
            tElement.style.height = pScaling.y + "px";
        }
        let tInteractor = new Interactor(tElement, this.mApp.viewer);
        tInteractor.position.copyFrom(pPosition);
        tInteractor.posOffsetDirection = pPosOffsetDir;
        tInteractor.posOffset = pPosOffset;
        tInteractor.customCssTransform = "translate(-50%, -50%)";
        if (p3dRotation != null) {
            tInteractor.transform3d = true;
            tInteractor.transform3dRotation = p3dRotation;
        }
        //update visibility
        tInteractor.onBeforeUpdateViewPosition = (pView) => {
            let tCameraVec = this.getDirectionToCamera(tInteractor.position, pView);
            let tDot = Vector3.Dot(VECTOR3_Y, tCameraVec);
            if (!pAllwaysVisible)
                tInteractor.visible = Math.abs(tDot) > 0.1;
            else
                tInteractor.visible = true;
        };
        this.mInteractorManager.addInteractor(tInteractor);
        return (tInteractor);
    }
    createTextInteractor(pPosition, pText, pTextDirection, pPosOffsetDir = null, pPosOffset = 0, p3dRotation = null, pDisabled = false, pUpdInstance = null, pAllwaysVisible = false, pInteractorId = "wcf-room text-interactor") {
        let tInteractor = pUpdInstance;
        if (tInteractor == null) {
            tInteractor = new TextInteractor(this.mApp.viewer);
            tInteractor.type = InteractorType.Button;
            //update visibility
            tInteractor.onBeforeUpdateViewPosition = (pView) => {
                let tCameraVec = this.getDirectionToCamera(tInteractor.position, pView);
                let tDot = Vector3.Dot(VECTOR3_Y, tCameraVec);
                tInteractor.visible = Math.abs(tDot) > 0.05;
            };
        }
        if (pDisabled)
            tInteractor.element.className = pInteractorId + "-disabled";
        else
            tInteractor.element.className = pInteractorId;
        tInteractor.position.copyFrom(pPosition);
        tInteractor.posOffsetDirection = pPosOffsetDir;
        tInteractor.posOffset = pPosOffset;
        tInteractor.textDirection = pTextDirection;
        tInteractor.customCssTransform = "translate(-50%, -50%)";
        if (p3dRotation != null) {
            tInteractor.transform3d = true;
            tInteractor.transform3dRotation = p3dRotation;
        }
        tInteractor.setText(pText);
        if (pUpdInstance != null)
            tInteractor.updateViewPosition();
        else
            this.mInteractorManager.addInteractor(tInteractor);
        //update visibility
        tInteractor.onBeforeUpdateViewPosition = (pView) => {
            if (tInteractor == null)
                return;
            let tCameraVec = this.getDirectionToCamera(tInteractor.position, pView);
            let tDot = Vector3.Dot(VECTOR3_Y, tCameraVec);
            if (!pAllwaysVisible)
                tInteractor.visible = Math.abs(tDot) > 0.1;
            else
                tInteractor.visible = true;
        };
        return (tInteractor);
    }
    createMeasureTextInteractor(pPosition, pText, pTextDirection, pPosOffsetDir = null, pPosOffset = 0, p3dRotation = null, pDisabled = false, pUpdInstance = null, pAllwaysVisible = false) {
        let tInteractor = pUpdInstance;
        if (tInteractor == null) {
            tInteractor = new TextInteractor(this.mApp.viewer);
            tInteractor.type = InteractorType.Button;
            //update visibility
            tInteractor.onBeforeUpdateViewPosition = (pView) => {
                let tCameraVec = this.getDirectionToCamera(tInteractor.position, pView);
                let tDot = Vector3.Dot(VECTOR3_Y, tCameraVec);
                tInteractor.visible = Math.abs(tDot) > 0.05;
            };
        }
        if (pDisabled)
            tInteractor.element.className = "wcf-room measureText-interactor-disabled";
        else
            tInteractor.element.className = "wcf-room measureText-interactor";
        tInteractor.position.copyFrom(pPosition);
        tInteractor.posOffsetDirection = pPosOffsetDir;
        tInteractor.posOffset = pPosOffset;
        tInteractor.textDirection = pTextDirection;
        tInteractor.customCssTransform = "translate(-50%, -50%)";
        if (p3dRotation != null) {
            tInteractor.transform3d = true;
            tInteractor.transform3dRotation = p3dRotation;
        }
        tInteractor.setText(pText);
        if (pUpdInstance != null)
            tInteractor.updateViewPosition();
        else
            this.mInteractorManager.addInteractor(tInteractor);
        //update visibility
        tInteractor.onBeforeUpdateViewPosition = (pView) => {
            if (tInteractor == null)
                return;
            let tCameraVec = this.getDirectionToCamera(tInteractor.position, pView);
            let tDot = Vector3.Dot(VECTOR3_Y, tCameraVec);
            if (!pAllwaysVisible)
                tInteractor.visible = Math.abs(tDot) > 0.1;
            else
                tInteractor.visible = true;
        };
        return (tInteractor);
    }
    getDirectionToCamera(pPos, pView) {
        let tCameraVec;
        if (pView.cameraControl.cameraMode === CameraMode.Perspective) {
            tCameraVec = pView.cameraControl.position.subtract(pPos);
            tCameraVec.normalize();
        }
        else
            tCameraVec = pView.cameraControl.direction.negate();
        return (tCameraVec);
    }
    showInputField(pId, pLength, pInteractor, pWall = null) {
        // disable dialog while create new objects
        if (this.mRoomManager.isInteracting)
            return;
        pInteractor.setactive(true);
        this.mRoomManager.onShowInputField(pId, pLength, pInteractor.element, pWall).then((pNewLength) => {
            if (pNewLength != null) {
                this.handleInputField(pId, pLength, pNewLength, pInteractor);
            }
            pInteractor.setactive(false);
        }).catch((pError) => {
            Log.error("onShowInputField failed", pError);
            pInteractor.setactive(false);
        });
    }
    showInputFieldText(pId, pText, pInteractor, pWall = null) {
        // disable dialog while create new objects
        if (this.mRoomManager.isInteracting)
            return;
        pInteractor.setactive(true);
        this.mRoomManager.onShowInputFieldText(pId, pText, pInteractor.element, pWall).then((pNewText) => {
            if (pNewText != null) {
                this.handleInputFieldText(pId, pText, pNewText, pInteractor);
            }
            pInteractor.setactive(false);
        }).catch((pError) => {
            Log.error("onShowInputField failed", pError);
            pInteractor.setactive(false);
        });
    }
    handleInputField(pId, pOldLength, pNewLength, pInteractor) {
        //
    }
    handleInputFieldText(pId, pOldText, pNewText, pInteractor) {
        //
    }
    async getAndCreateInteractors() {
        await AbstractInteractors.PrepareSprite(this.mRoomManager.dataPath);
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
AbstractInteractors.sSpriteUrl = null;
